export default "__VITE_ASSET__B7iJBp68__"